<div class="box box--min-height right-box scroll-host u-ml--" wfmScrollbar>
  <div class="search-result-container" *ngIf="patientList.length!=0; else noResultFound">
    <button
      class="card__button u-mb---"
      [disabled]="sourcePatientId && sourcePatientId === patient.patientId"
      *ngFor="let patient of patientList"
      (click)="selectDestinationPatient(patient)"
    >
      <div class="card card__container card__container--stroke flex flex--col" style="width: 32.4rem">
        <div class="card__content u-mt---- u-mh- u-mb----">
          <div class="card__title-block">
            <h2 class="heading-16 text-bold u-m0 patient-detail-value">{{ patient.name.text }}</h2>
          </div>
          <div class="card__body-block">
            <div class="patient-detail-content">
              <span class="patient-detail-label text-14">{{'label.pid'| translate}}</span>
              <p
                [tooltip]="patient.mrn.domainIdentifier"
                [overflowOnly]="true"
                class="patient-detail-value patient-mrn text-14 text-ellipsis u-ml---"
              >
                {{ patient.mrn.domainIdentifier }}
              </p>
              <span class="patient-detail-label text-14 u-ml--">{{'label.dob' | translate}}</span>
              <span class="patient-detail-value text-14 u-ml---"
                >{{ patient.birthDate | dateTime: dateTimePref.dateFormat }}
              </span>
            </div>
            <div class="patient-detail-content u-m0">
              <span class="patient-detail-label text-14">{{'label.gender'| translate}}</span>
              <span class="patient-detail-value text-14 u-ml---">{{ patient.gender }}</span>
              <span class="patient-detail-label text-14 u-ml--">{{'label.age'| translate}}</span>
              <span class="patient-detail-value text-14 u-ml---"> {{ getPatientAge(patient) }} </span>
            </div>
          </div>
        </div>
      </div>
    </button>
  </div>
  <ng-template #noResultFound>
    <div class="no-search-result">    
      <div class="text-bold-20">
        
      <span>{{'notification.workList.search.primary' | translate}}</span> 
      
      <span *ngIf="searchFormValue.pid !== '' && searchFormValue.pid !== undefined">
        <span>{{'label.pid'| translate}}: {{searchFormValue.pid}}</span>
      </span>
      <span *ngIf="searchFormValue.patientName !== '' && searchFormValue.patientName !== undefined">
        <span>
          {{'searchModule.lastFirstNameLabel' | translate}}: {{searchFormValue.patientName}}
        </span>
      </span>
      
      </div>

      <div class="text-16 u-ph+ u-pt---">
        {{'notification.workList.search.secondary' | translate}}
      </div>
    </div>
  </ng-template>
</div>
